import React from 'react'
import {IconButton as MuiIconButton, Tooltip} from '@material-ui/core';
import PropTypes from 'prop-types';
import AcUnitIcon from '@material-ui/icons/AcUnit';


function IconButton(
    {
        tooltip,
        placement = 'top',
        hideTooltip = false,
        Icon = AcUnitIcon,
        children,
        disabled,
        color,
        ...props
    }) {
    const button = (
        <MuiIconButton color={color} disabled={disabled} {...props} >
            <Icon/>
            {children}
        </MuiIconButton>
    )

    if (hideTooltip || !Boolean(tooltip)) {
        return button
    }
    return (
        <Tooltip title={tooltip} placement={placement}>
			<span>
				{button}
			</span>
        </Tooltip>
    )
}

IconButton.propTypes = {
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    placement: PropTypes.string,
    hideTooltip: PropTypes.bool,
    Icon: PropTypes.elementType,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default IconButton;